// // Action names should be imported from their respective action modules
import {
    GET_TABLEDATA_BEGIN,
    GET_TABLEDATA_SUCCESS,
    GET_TABLEDATA_FAILURE,
    CLEAR_COURSES,
} from '../actions/DataTableActions';

// Example initial state
const initialState = {
    item: {},
    byId: {},
    allIds: [],
    isLoading: false,
    error: '',
    courseName: []
};

// Return a new state object with updated attributes
export default function TableDataReducer(state = initialState, action) {
    switch (action.type) {
        case GET_TABLEDATA_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case GET_TABLEDATA_SUCCESS:
            return {
                ...state,
                item: action.payload.data,
                isLoading: false,
                error: ''
            }
        case GET_TABLEDATA_FAILURE:
            return {
                ...state,
                error: action.payload.error,
                isLoading: false
            }
        case CLEAR_COURSES:
            return {
                ...state,
                byId: {},
                allIds: [],
                isLoading: false,
            }
        default:
            return state;
    }
};


export const getErrorTableData = state => {
    return state.error;
}

export const getIsLoadingTableData = state => {
    return state.isLoading;
}

export const getTableData = state => {
    return state.item;
}